/* eslint-disable */

import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

const commonEndPoint = 'api/V2/';
const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');
let merchantEmpID;
const isEmployee = localStorage.getItem('isEmployee');
if (isEmployee === 'true') {
    merchantEmpID = localStorage.getItem('empId');
}
export const commonPost = async (apiEndPoint, payload, params) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.post(
            endPoint,
            payload,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
export const commonGetRequest = async (apiEndPoint, params) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.get(
            endPoint,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
const handleApiRequest = async (method, endpoint, payload = null) => {
    try {
        const response =
            method === 'GET'
                ? await commonGetRequest(endpoint, payload) // Pass params for GET
                : await commonPost(endpoint, payload); // Pass body for POST

        return response;
    } catch (error) {
        console.error('API Error:', error);
        return null;
    }
};
export const GET_API_ENDPOINTS = {
    getState: 'moneytransfer/SdistEmployee/states',
    getDistrict: 'moneytransfer/SdistEmployee/district',
    //Quickly pay special dashboard apis starts here>>>>
    getDashboard: 'moneytransfer/SdistEmployee/quicklypay/getDashboard'
    //Quickly pay special dashboard apis starts here>>>>
};
export const POST_API_ENDPOINTS = {
    updateBatches: 'moneytransfer/SdistEmployee/UpdatestatusBatches',
    listAllBatches: 'moneytransfer/SdistEmployee/ListAllBatches',
    balance: 'moneytransfer/SdistEmployee/balance',
    listEmployeeTransactions: 'moneytransfer/SdistEmployee/listEmployeetransactions',
    profile: 'moneytransfer/SdistEmployee/profile',
    resetPassword: 'moneytransfer/SdistEmployee/Setresetpassword',
    updateProfile: 'moneytransfer/SdistEmployee/UpdateProfile',
    //Quickly pay special dashboard apis starts here>>>>
    getEntity: 'moneytransfer/SdistEmployee/quicklypay/getEntity',
    ledgerEntry: 'moneytransfer/SdistEmployee/quicklypay/dayBookEntry',
    dayBookList: 'moneytransfer/SdistEmployee/quicklypay/dayBookList',
    dayBookApproval: 'moneytransfer/SdistEmployee/quicklypay/dayBookApproval',
    editLedgerEntry: 'moneytransfer/SdistEmployee/quicklypay/editDayBookEntry',
    allTransactionList: 'moneytransfer/SdistEmployee/quicklypay/allTransactionList',
    deleteDayBook: 'moneytransfer/SdistEmployee/quicklypay/deleteDayBook'
    //Quickly pay special dashboard apis ends here>>>>
};
//Quickly pay special dashboard apis starts here>>>>

export const getBatchUpdate = async (payload) => {
    //API FOR UPDATE BATCHES
    const response = await commonPost(POST_API_ENDPOINTS.updateBatches, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getListAllBatches = async (payload) => {
    //API FOR LIST ALL BATCHES
    const response = await commonPost(POST_API_ENDPOINTS.listAllBatches, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const fetchBalanceApi = async (payload) => {
    //API FOR Dashboard balance
    const response = await commonPost(POST_API_ENDPOINTS.balance, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getListEmployeeTransactions = async (payload) => {
    //API FOR LIst EMployee transactions
    const response = await commonPost(POST_API_ENDPOINTS.listEmployeeTransactions, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getProfileApi = async (payload) => {
    //API FOR Profile
    const response = await commonPost(POST_API_ENDPOINTS.profile, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const resetPasswordApi = async (payload) => {
    //API FOR Reset PAssword Api
    const response = await commonPost(POST_API_ENDPOINTS.resetPassword, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getDistrictApi = async (params) => {
    //API FOR Get Dist
    const response = await commonGetRequest(GET_API_ENDPOINTS.getDistrict, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getStateApi = async (params) => {
    //API FOR Get State
    const response = await commonGetRequest(GET_API_ENDPOINTS.getState, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const updateProfileApi = async (payload) => {
    //API FOR Update Profile
    const response = await commonPost(POST_API_ENDPOINTS.updateProfile, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
//Quickly pay special dashboard apis starts here>>>>
export const getEntityApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getEntity, payload);
export const ledgerEntryApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ledgerEntry, payload);
export const dayBookListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.dayBookList, payload);
export const getDashboardApiApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.getDashboard, payload);
export const dayBookApprovalApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.dayBookApproval, payload);
export const editLedgerEntryApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.editLedgerEntry, payload);
export const allTransactionListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.allTransactionList, payload);
export const deleteDayBookApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.deleteDayBook, payload);
//Quickly pay special dashboard apis ends here<<<<
